module.exports = __webpack_public_path__ + "img/menu_bfbt_c.901c7a83.png";